import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 12.5V21a1 1 0 1 1-2 0V4.029c0-.625.314-1.097.657-1.4a2.7 2.7 0 0 1 1.087-.565c1.101-.292 2.096-.39 3.192-.208 1.07.177 2.175.611 3.51 1.278 1.225.611 2.227.512 3.03.391l.149-.022c.156-.025.326-.05.472-.067.19-.022.458-.043.73.008.307.059.667.221.913.591.219.328.26.69.26.965v7c0 .619-.319 1.08-.648 1.372-.32.285-.705.466-1.036.577-1.893.63-4.218-.015-5.87-1.117C10.422 12.15 8 12 7 12.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_flag_filled-BCOSqhT1.js.map
